module.exports = __webpack_public_path__ + "static/media/8.ec32f49d.jpg";